import * as types from '../constants';

const initialState = {
  name: '',
  role: '',
};

const HeaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_HEADER_ITEM:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default HeaderReducer;